import { Center, Stack } from '@mantine/core';
import H1Medium from 'components/typography/H1Medium';
import P1Regular from 'components/typography/P1Regular';

/** Shared authenticated not-found page. */
export default function NotFoundPage() {
  return (
    <Center h="100vh">
      <Stack align="center" spacing={8}>
        <H1Medium>404</H1Medium>
        <P1Regular>Požadovaná stránka sa nenašla.</P1Regular>
      </Stack>
    </Center>
  );
}
